import React from 'react';
import { Box, Typography } from '@mui/material';
import TicketForm from './components/TicketForm';
import './styles.scss';
import Heading from '../../../../components/Heading';
import HPDTicketIcon from '../../../../styles/svg/hpd-tickets.svg';

const HPDTickets = () => {
  const handleFormSubmit = () => {
    // Handle after submission logic if needed
  };

  return (
    <div className="hpd-tickets-container">
      <Heading title="HPD Violation Ticket" icon={HPDTicketIcon} />

      <Box className="ticket-form-wrapper mt-4">
        <TicketForm onClose={handleFormSubmit} />
      </Box>
    </div>
  );
};

export default HPDTickets; 